(function() {
	PM.Weekly = {};

	// ── Color system ──────────────────────────────────────────

	PM.Weekly.colors = {
		stops: []
	};

	PM.Weekly.stripeColors = {
		stops: [
			{ percent: 0,   color: '#f0f4f8' },
			{ percent: 25,  color: '#b3d4ff' },
			{ percent: 50,  color: '#5c9ce6' },
			{ percent: 75,  color: '#2563eb' },
			{ percent: 100, color: '#1e3a5f' }
		]
	};

	PM.Weekly.hexToRgb = function(hex) {
		if (!hex || hex === '') return null;
		var h = hex.replace('#', '');
		if (h.length === 3) {
			h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
		}
		return {
			r: parseInt(h.substring(0, 2), 16),
			g: parseInt(h.substring(2, 4), 16),
			b: parseInt(h.substring(4, 6), 16)
		};
	};

	PM.Weekly.getCellBgStyle = function(ratio) {
		var stops = PM.Weekly.colors.stops;
		if (!stops || !stops.length) return '';

		var pct = ratio * 100;

		var lower = null, upper = null;
		for (var i = 0; i < stops.length; i++) {
			if (stops[i].percent <= pct) {
				lower = stops[i];
			}
			if (stops[i].percent >= pct && upper === null) {
				upper = stops[i];
			}
		}

		if (!lower && !upper) return '';
		if (!lower) lower = upper;
		if (!upper) upper = lower;

		if (lower.percent === upper.percent) {
			if (!lower.color) return '';
			return 'background-color: ' + lower.color;
		}

		var t = (pct - lower.percent) / (upper.percent - lower.percent);
		var lowerRgb = PM.Weekly.hexToRgb(lower.color);
		var upperRgb = PM.Weekly.hexToRgb(upper.color);

		if (!lowerRgb && !upperRgb) return '';
		if (!lowerRgb) {
			return 'background-color: rgba(' + upperRgb.r + ', ' + upperRgb.g + ', ' + upperRgb.b + ', ' + t.toFixed(2) + ')';
		}
		if (!upperRgb) {
			return 'background-color: rgba(' + lowerRgb.r + ', ' + lowerRgb.g + ', ' + lowerRgb.b + ', ' + (1 - t).toFixed(2) + ')';
		}

		var r = Math.round(lowerRgb.r + (upperRgb.r - lowerRgb.r) * t);
		var g = Math.round(lowerRgb.g + (upperRgb.g - lowerRgb.g) * t);
		var b = Math.round(lowerRgb.b + (upperRgb.b - lowerRgb.b) * t);
		return 'background-color: rgb(' + r + ', ' + g + ', ' + b + ')';
	};

	PM.Weekly.getStripeBgStyle = function(ratio) {
		var stops = PM.Weekly.stripeColors.stops;
		if (!stops || !stops.length) return '';

		var pct = ratio * 100;

		var lower = null, upper = null;
		for (var i = 0; i < stops.length; i++) {
			if (stops[i].percent <= pct) lower = stops[i];
			if (stops[i].percent >= pct && upper === null) upper = stops[i];
		}

		if (!lower && !upper) return '';
		if (!lower) lower = upper;
		if (!upper) upper = lower;

		if (lower.percent === upper.percent) {
			if (!lower.color) return '';
			return 'background-color: ' + lower.color;
		}

		var t = (pct - lower.percent) / (upper.percent - lower.percent);
		var lowerRgb = PM.Weekly.hexToRgb(lower.color);
		var upperRgb = PM.Weekly.hexToRgb(upper.color);

		if (!lowerRgb && !upperRgb) return '';
		if (!lowerRgb) {
			return 'background-color: rgba(' + upperRgb.r + ', ' + upperRgb.g + ', ' + upperRgb.b + ', ' + t.toFixed(2) + ')';
		}
		if (!upperRgb) {
			return 'background-color: rgba(' + lowerRgb.r + ', ' + lowerRgb.g + ', ' + lowerRgb.b + ', ' + (1 - t).toFixed(2) + ')';
		}

		var r = Math.round(lowerRgb.r + (upperRgb.r - lowerRgb.r) * t);
		var g = Math.round(lowerRgb.g + (upperRgb.g - lowerRgb.g) * t);
		var b = Math.round(lowerRgb.b + (upperRgb.b - lowerRgb.b) * t);
		return 'background-color: rgb(' + r + ', ' + g + ', ' + b + ')';
	};

	PM.Weekly.fetchColors = function() {
		return $.get('/api/plan/colors').then(function(data) {
			PM.Weekly.colors.stops = data;
			return data;
		});
	};

	// ── Week structure state ──────────────────────────────────

	PM.Weekly.weekStructure = null;
	PM.Weekly.totalWeeks = 0;

	PM.Weekly.scrollToCurrentMonth = function(containerSelector, weekStructure) {
		if (!weekStructure || !weekStructure.monthGroups || !weekStructure.monthGroups.length) return;

		var now = new Date();
		var targetMonth = now.getUTCMonth() - 1;
		var targetYear = now.getUTCFullYear();
		if (targetMonth < 0) {
			targetMonth = 11;
			targetYear -= 1;
		}

		var groupIndex = -1;
		for (var i = 0; i < weekStructure.monthGroups.length; i++) {
			var mg = weekStructure.monthGroups[i];
			if (mg.year === targetYear && mg.month === targetMonth) {
				groupIndex = i;
				break;
			}
		}

		if (groupIndex < 0 && weekStructure.monthGroups.length > 0) {
			for (var j = 0; j < weekStructure.monthGroups.length; j++) {
				var mg2 = weekStructure.monthGroups[j];
				if (mg2.year > targetYear || (mg2.year === targetYear && mg2.month > targetMonth)) {
					groupIndex = Math.max(0, j - 1);
					break;
				}
			}
			if (groupIndex < 0) groupIndex = weekStructure.monthGroups.length - 1;
		}

		if (groupIndex < 0) return;

		var $container = $(containerSelector);
		if (!$container.length) return;

		var $firstRow = $container.find('thead tr:first-child');
		var $allThs = $firstRow.children('th');
		var offsetThs = 0;
		for (var t = 0; t < $allThs.length; t++) {
			var colspan = parseInt($allThs.eq(t).attr('colspan') || '', 10);
			if (!isNaN(colspan) && colspan > 1) break;
			offsetThs++;
		}

		var $monthTh = $allThs.eq(offsetThs + groupIndex);

		setTimeout(function() {
			var $scrollTarget = $container.find('.table-responsive').first();
			if (!$scrollTarget.length) $scrollTarget = $container;
			if ($monthTh.length) {
				var scrollPos = $monthTh[0].offsetLeft;
				var padding = $container.find('.js-sticky-col-1').first().outerWidth(true) || 220;
				$scrollTarget.scrollLeft(scrollPos - padding - 8);
			}
		}, 100);
	};

	PM.Weekly.highlightCurrentWeek = function(containerSelector, weekStructure) {
		if (!weekStructure || !weekStructure.weeks || !weekStructure.weeks.length) return;

		var now = new Date();
		var todayYear = now.getUTCFullYear();
		var jan1 = new Date(Date.UTC(todayYear, 0, 1));
		var jan1Dow = jan1.getUTCDay();
		var daysUntilMonday = jan1Dow === 0 ? 1 : (jan1Dow === 1 ? 0 : 8 - jan1Dow);
		var firstMonday = new Date(Date.UTC(todayYear, 0, 1 + daysUntilMonday));
		var todayStart = new Date(Date.UTC(todayYear, now.getUTCMonth(), now.getUTCDate()));
		var diffMs = todayStart.getTime() - firstMonday.getTime();
		var currentPerYearWeek = Math.max(1, Math.floor(diffMs / (7 * 24 * 60 * 60 * 1000)) + 1);

		var currentWeekIndex = -1;
		for (var w = 0; w < weekStructure.weeks.length; w++) {
			var weekData = weekStructure.weeks[w];
			if (weekData.year === todayYear && weekData.perYearWeek === currentPerYearWeek) {
				currentWeekIndex = w;
				break;
			}
		}

		if (currentWeekIndex < 0) return;

		var $container = $(containerSelector);
		if (!$container.length) return;

		var $firstRow = $container.find('thead tr:first-child');
		var offsetThs = 0;
		$firstRow.children('th').each(function() {
			var colspan = parseInt($(this).attr('colspan') || '', 10);
			if (!isNaN(colspan) && colspan > 1) return false;
			offsetThs++;
		});

		var $table = $container.find('table');
		if (!$table.length) return;

		var colSelector = 'col:nth-child(' + (offsetThs + currentWeekIndex + 1) + '), ' +
			'thead tr:last-child th:nth-child(' + (offsetThs + currentWeekIndex + 1) + '), ' +
			'tbody tr td:nth-child(' + (offsetThs + currentWeekIndex + 1) + '), ' +
			'tbody tr th:nth-child(' + (offsetThs + currentWeekIndex + 1) + ')';

		$table.find(colSelector).addClass('js-current-week');
	};

	// ── Shared month range ────────────────────────────────────

	PM.Weekly.monthOffset = function(offset) {
		var now = new Date();
		var month = new Date(now.getFullYear(), now.getMonth() + offset, 1);
		return month.getFullYear() + '-' + String(month.getMonth() + 1).padStart(2, '0');
	};

	PM.Weekly.monthRange = null;
	PM.Weekly.getMonthRange = function() {
		if (!PM.Weekly.monthRange) {
			PM.Weekly.monthRange = { fromMonth: PM.Weekly.monthOffset(-2), toMonth: PM.Weekly.monthOffset(10) };
		}
		return PM.Weekly.monthRange;
	};

	PM.Weekly.onMonthChange = null;

	// ── Zoom bar ──────────────────────────────────────────────

	PM.Weekly.showZoomBar = function() {
		var $existing = $('.js-weekly-zoom-bar');
		if ($existing.length) {
			$existing.show();
			_applyZoom();
		} else {
			var result = ejs.rr('/app/plan/templates/zoom-bar.ejs', {});
			if (typeof result === 'string') {
				$('body').append(result);
				_applyZoom();
			} else {
				$.when(result).done(function(zoomBarHtml) {
					$('body').append(zoomBarHtml);
					_applyZoom();
				});
			}
		}
		$('body').addClass('js-has-zoom-bar');

		function _applyZoom() {
			var $slider = $('.js-weekly-zoom-slider');
			if ($slider.length) {
				var scale = parseInt($slider.val(), 10) / 100;
				$('.js-weekly-zoom-target').css('zoom', scale);
			}
		}
	};

	PM.Weekly.hideZoomBar = function() {
		$('.js-weekly-zoom-bar').hide();
		$('body').removeClass('js-has-zoom-bar');
	};

	// ── Stripe mode ───────────────────────────────────────────

	PM.Weekly.stripeMode = false;

	PM.Weekly.applyStripeColors = function(rowSelector, inputSelector) {
		var maxHours = 0;

		$(rowSelector).each(function() {
			var $row = $(this);
			$row.find(inputSelector).each(function() {
				var $input = $(this);
				var rawVal = $input.data('raw-value');
				var hours;
				if (rawVal !== undefined && rawVal !== '') {
					hours = parseFloat(rawVal);
				} else {
					var val = $input.val().trim();
					hours = val !== '' ? PM.Utils.parseNumber(val) : NaN;
				}
				if (!isNaN(hours) && hours > maxHours) {
					maxHours = hours;
				}
			});
		});

		$(rowSelector).each(function() {
			var $row = $(this);
			$row.find(inputSelector).each(function() {
				var $input = $(this);
				var rawVal = $input.data('raw-value');
				var hours;
				if (rawVal !== undefined && rawVal !== '') {
					hours = parseFloat(rawVal);
				} else {
					var val = $input.val().trim();
					hours = val !== '' ? PM.Utils.parseNumber(val) : NaN;
				}
				var ratio = (!isNaN(hours) && maxHours > 0) ? (hours / maxHours) : 0;
				var bgStyle = PM.Weekly.getStripeBgStyle(ratio);
				$input.closest('td').attr('style', bgStyle);
			});
		});
	};

	PM.Weekly.removeStripeColors = function(rowSelector, inputSelector) {
		$(rowSelector).find(inputSelector).each(function() {
			$(this).closest('td').removeAttr('style');
		});
	};

	PM.Weekly.getStripeRowSelectors = function() {
		return '.js-project-row, .js-person-assign-row';
	};

	PM.Weekly.getPlanInputSelector = function() {
		return '.js-plan-week-input';
	};

	// ── Column resize ─────────────────────────────────────────

	var colResize = {
		isResizing: false,
		startX: 0,
		startWidth: 0,
		handle: null,
		selectors: '',
		storageKey: ''
	};

	PM.Weekly.initColumnResize = function(cellSelectors, storageKey) {
		var $cells = $(cellSelectors);
		$cells.each(function() {
			if (!$(this).find('.js-col-resize-handle').length) {
				$(this).append('<div class="js-col-resize-handle"></div>');
			}
		});

		var savedWidth = localStorage.getItem(storageKey);
		if (savedWidth) {
			$cells.css({ width: savedWidth + 'px', 'min-width': savedWidth + 'px' });
		}

		colResize.selectors = cellSelectors;
		colResize.storageKey = storageKey;
	};

	// ── Event handlers ────────────────────────────────────────

	// Month range filter change
	$(document).on('change', '.js-weekly-month-from-filter, .js-weekly-month-to-filter', function() {
		var fromMonth = $('.js-weekly-month-from-filter').val();
		var toMonth = $('.js-weekly-month-to-filter').val();
		if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(fromMonth) ||
			!/^\d{4}-(0[1-9]|1[0-2])$/.test(toMonth) || fromMonth > toMonth) {
			new Notify({ status: 'error', text: i18next.t('Enter a valid month range.'), timeout: 3000 });
			return;
		}
		PM.Weekly.monthRange = { fromMonth: fromMonth, toMonth: toMonth };
		if (typeof PM.Weekly.onMonthChange === 'function') PM.Weekly.onMonthChange();
	});

	// Zoom slider
	$(document).on('input', '.js-weekly-zoom-slider', function() {
		var zoomVal = parseInt($(this).val(), 10);
		var scale = zoomVal / 100;
		var $target = $('.js-weekly-zoom-target');
		$target.css('zoom', scale);
		$('.js-weekly-zoom-value').text(zoomVal + '%');
	});

	// Stripe mode toggle
	$(document).on('click', '.js-weekly-stripe-toggle', function() {
		PM.Weekly.stripeMode = !PM.Weekly.stripeMode;
		var $btn = $(this);
		if (PM.Weekly.stripeMode) {
			$btn.addClass('active');
			if (typeof PM.Weekly._stripeApply === 'function') {
				PM.Weekly._stripeApply();
			}
		} else {
			$btn.removeClass('active');
			if (typeof PM.Weekly._stripeRemove === 'function') {
				PM.Weekly._stripeRemove();
			}
		}
	});

	// Column resize drag
	$(document).on('mousedown', '.js-col-resize-handle', function(e) {
		e.preventDefault();
		e.stopPropagation();

		if (!colResize.selectors) return;

		var $cell = $(this).closest(colResize.selectors);
		var cellWidth = $cell.outerWidth();

		colResize.isResizing = true;
		colResize.startX = e.pageX;
		colResize.startWidth = cellWidth;
		colResize.handle = this;

		$('body').addClass('js-col-resizing');
		$(this).addClass('js-active');
	});

	$(document).on('mousemove', function(e) {
		if (!colResize.isResizing) return;

		var delta = e.pageX - colResize.startX;
		var newWidth = Math.max(220, colResize.startWidth + delta);

		if (colResize.selectors) {
			$(colResize.selectors).css({
				width: newWidth + 'px',
				'min-width': newWidth + 'px'
			});
		}
	});

	$(document).on('mouseup', function() {
		if (!colResize.isResizing) return;

		if (colResize.selectors) {
			var newWidth = $(colResize.selectors).first().outerWidth();
			localStorage.setItem(colResize.storageKey, newWidth);
		}

		$('body').removeClass('js-col-resizing');
		if (colResize.handle) {
			$(colResize.handle).removeClass('js-active');
		}

		colResize.isResizing = false;
		colResize.handle = null;
	});
})();
